import { BarChart3, LineChart as LineIcon, Activity, Ruler, TrendingUp } from "lucide-react";

const MA_PERIODS = [3, 5, 10];

const Seg = ({ active, onClick, testId, children }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-data font-semibold transition-colors whitespace-nowrap ${
      active ? "bg-[#00E5FF] text-[#0B0F17]" : "text-slate-400 hover:text-white"
    }`}
  >
    {children}
  </button>
);

// One set of chart controls for every stat chart: Bars/Line + Moving Average + Fibonacci.
export const ChartControls = ({ view, onChange }) => (
  <div data-testid="chart-controls" className="flex items-center gap-2 flex-wrap">
    <div className="inline-flex rounded-lg border border-[#233248] bg-[#0B0F17] p-0.5">
      <Seg testId="chart-type-bar" active={view.type === "bar"} onClick={() => onChange({ ...view, type: "bar" })}>
        <BarChart3 className="h-3 w-3" /> Bars
      </Seg>
      <Seg testId="chart-type-line" active={view.type === "line"} onClick={() => onChange({ ...view, type: "line" })}>
        <LineIcon className="h-3 w-3" /> Line
      </Seg>
    </div>
    <div className="inline-flex items-center rounded-lg border border-[#233248] bg-[#0B0F17] p-0.5">
      <Seg testId="indicator-ma-toggle" active={!!view.ma} onClick={() => onChange({ ...view, ma: view.ma ? null : 5 })}>
        <Activity className="h-3 w-3" /> Moving Avg
      </Seg>
      {view.ma &&
        MA_PERIODS.map((n) => (
          <button
            key={n}
            data-testid={`indicator-ma-${n}`}
            onClick={() => onChange({ ...view, ma: n })}
            className={`rounded-md px-1.5 py-1 text-[11px] font-data font-bold transition-colors ${
              view.ma === n ? "text-[#F43F5E]" : "text-slate-500 hover:text-white"
            }`}
          >
            {n}
          </button>
        ))}
    </div>
    <div className="inline-flex rounded-lg border border-[#233248] bg-[#0B0F17] p-0.5">
      <Seg testId="indicator-trend-toggle" active={view.trend !== false} onClick={() => onChange({ ...view, trend: view.trend === false })}>
        <TrendingUp className="h-3 w-3" /> Trend line
      </Seg>
    </div>
    <div className="inline-flex rounded-lg border border-[#233248] bg-[#0B0F17] p-0.5">
      <Seg testId="indicator-fib-toggle" active={view.fib} onClick={() => onChange({ ...view, fib: !view.fib })}>
        <Ruler className="h-3 w-3" /> Fibonacci
      </Seg>
    </div>
  </div>
);
